<!-- eslint-disable camelcase -->
<script>
import { mapState, mapActions } from 'vuex'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { VueGoodTable } from 'vue-good-table'
import { SweetModal } from 'sweet-modal-vue'
import VuePdfApp from 'vue-pdf-app'
import { debounce } from 'vue-debounce'
import vSelect from 'vue-select'
import PaginationCustom from '@/components/table/Pagination.vue'
import appData from '@/data'
import kodeDaerah from '@/data/modules/kodeDaerah'
import 'vue-pdf-app/dist/icons/main.css'

export default {
   name: 'OssLkpmUmk',
   components: {
      BCardCode,
      VueGoodTable,
      PaginationCustom,
      SweetModal,
      VuePdfApp,
      vSelect,
   },
   filters: {
      formatKey(value) {
         if (!value) return ''
         const str = String(value).replace(/_/g, ' ')
         return str.charAt(0).toUpperCase() + str.slice(1)
      },
   },
   data() {
      return {
         pdf: '',
         loadingPdf: false,
         loading: true,
         detailItem: {},
         detailSections: [],
         serverParams: {
            columnFilters: {},
            sort: {
               field: '',
               type: '',
            },
            search: '',
            page: 1,
            perPage: 10,
            filter: {
               jenis_perusahaan: null,
               status_penanaman_modal: null,
               kd_skala_usaha: null,
               kd_resiko: null,
               sektor: null,
               perusahaan_daerah_id: null,
               daerah_mode: 'kecamatan',
               periode_lkpm: null,
               tahun_lkpm: null,
               status: null,
            },
         },
         pageLength: 10,
         pageOptions: ['10', '25', '50', '100'],
         searchTerm: '',
         isFilterOpen: false,
         columns: [
            {
               label: 'LKPM',
               field: 'nomor_lkpm',
               sortable: false,
               thClass: 'text-center',
            },
            {
               label: 'NIB',
               field: 'nib',
               sortable: false,
               thClass: 'text-center',
            },
            {
               label: 'Bidang Usaha',
               field: 'kbli',
               sortable: false,
               thClass: 'text-center',
            },
            {
               label: 'Tambahan Tenaga Kerja',
               field: 'tenaga_kerja',
               sortable: false,
               thClass: 'text-center',
            },
            {
               label: 'Rencana Nilai Investasi',
               field: 'rencana_investasi',
               sortable: false,
               thClass: 'text-center',
            },
            {
               label: 'Tambahan Nilai Investasi',
               field: 'tambahan_investasi',
               sortable: false,
               thClass: 'text-center',
            },
            {
               label: 'Action',
               field: 'action',
               sortable: false,
               thClass: 'text-center',
            },
         ],
      }
   },

   computed: {
      ...mapState({
         myData: state => state.OssLkpmUmk.items,
         myCount: state => state.OssLkpmUmk.countAll,
      }),
      jenisPerusahaan() {
         const data = appData.jenisPerusahaan
         return status => (data[status] ? data[status] : status)
      },
      skalaUsaha() {
         const data = appData.skalaUsaha
         return status => (data[status] ? data[status] : status)
      },
      statusPM() {
         const data = appData.statusPm
         return status => (data[status] ? data[status] : status)
      },
      statusResiko() {
         const data = appData.statusResiko
         return status => (data[status] ? data[status] : '-')
      },
      sektorCode() {
         const data = appData.sektor
         return status => (data[status] ? data[status] : status)
      },
      optionsJenisPerusahaan() {
         return Object.entries(appData.jenisPerusahaan).map(([value, text]) => ({ value, text }))
      },
      optionsStatusPM() {
         return Object.entries(appData.statusPm).map(([value, text]) => ({ value, text }))
      },
      optionsSkalaUsaha() {
         return Object.entries(appData.skalaUsaha).map(([value, text]) => ({ value, text }))
      },
      optionsStatusResiko() {
         return Object.entries(appData.statusResiko).map(([value, text]) => ({ value, text }))
      },
      optionsSektor() {
         return Object.entries(appData.sektor).map(([value, text]) => ({ value, text }))
      },
      optionsDaerah() {
         return kodeDaerah.map(item => ({
            value: item.kode,
            text: `${item.kode} - ${item.kecamatan} - ${item.kelurahan}`,
         }))
      },
      optionsPeriodeLkpm() {
         return [
            { value: 1, text: 'Semester 1' },
            { value: 2, text: 'Semester 2' },
         ]
      },
      optionsTahunLkpm() {
         const years = []
         const currentYear = new Date().getFullYear()
         for (let year = currentYear; year >= currentYear - 10; year -= 1) {
            years.push({ value: year, text: String(year) })
         }
         return years
      },
      optionsStatusLkpm() {
         return ['DISETUJUI', 'DRAF', 'TERKIRIM', 'PERLU PERBAIKAN', 'SUDAH DIPERBAIKI'].map(
            item => ({ value: item, text: item }),
         )
      },
      momentDate() {
         return datetime => (datetime ? this.$moment(datetime).format('DD-MM-YYYY') : '-')
      },
   },
   watch: {
      loadingPdf(val) {
         if (val) {
            this.$swal({ text: 'Loading', allowOutsideClick: false })
            this.$swal.showLoading()
         } else {
            this.$swal.close()
         }
      },
   },
   mounted() {
      this.loadItems()
   },
   methods: {
      ...mapActions({
         getData: 'OssLkpmUmk/getData',
         cetakLkpm: 'OssLkpmUmk/cetak',
         cetakListLkpm: 'OssLkpmUmk/cetakList',
      }),
      statusVariant(status) {
         return status === 'DISETUJUI' ? 'success' : 'danger'
      },
      periodeLabel(periode) {
         if (Number(periode) === 1) return 'Semester I'
         if (Number(periode) === 2) return 'Semester II'
         return periode || '-'
      },
      onDetail(row) {
         this.detailItem = row
         this.generateDetailSections(row)
         this.$bvModal.show('modal-detail')
      },
      generateDetailSections(item) {
         const { formatNumber } = this.$options.filters
         const tkiL = Number(item.tambahan_tki_l_ppelaporan || 0)
         const tkiP = Number(item.tambahan_tki_p_ppelaporan || 0)

         this.detailSections = [
            {
               title: 'Informasi LKPM',
               icon: 'FileTextIcon',
               rows: [
                  { name: 'Nomor LKPM', value: item.id_laporan || '-' },
                  { name: 'Periode', value: this.periodeLabel(item.periode_laporan) },
                  { name: 'Tahun', value: item.tahun_laporan || '-' },
                  { name: 'Tanggal Laporan', value: this.momentDate(item.tanggal_laporan) },
                  { name: 'Status', value: item.status || '-' },
               ],
            },
            {
               title: 'Perusahaan',
               icon: 'BriefcaseIcon',
               rows: [
                  { name: 'Nama Perusahaan', value: item.nama_perusahaan || '-' },
                  { name: 'NIB', value: item.nib || '-' },
                  { name: 'Jenis Perusahaan', value: this.jenisPerusahaan(item.jenis_perusahaan) },
                  { name: 'Status Penanaman Modal', value: this.statusPM(item.status_penanaman_modal) },
                  { name: 'Terbit NIB', value: this.momentDate(item.tanggal_terbit_oss || '-') },
                  { name: 'Nomor Telp', value: item.nomor_telp_perusahaan || '-' },
                  { name: 'Email', value: item.email || '-' },
                  { name: 'Alamat', value: item.alamat_perusahaan || '-' },

               ],
            },
            {
               title: 'Bidang Usaha',
               icon: 'LayersIcon',
               rows: [
                  { name: 'KBLI', value: item.kbli || '-' },
                  { name: 'Judul KBLI', value: item.kbli_nama || '-' },
                  { name: 'Nama Usaha', value: item.nama_usaha || '-' },
                  { name: 'Risiko', value: this.statusResiko(item.kd_resiko) },
                  { name: 'Skala Usaha', value: this.skalaUsaha(item.kd_skala_usaha) },
                  { name: 'Sektor', value: this.sektorCode(item.sektor) },
                  { name: 'ID Proyek', value: item.id_proyek || '-' },
               ],
            },
            {
               title: 'Tambahan Tenaga Kerja',
               icon: 'UsersIcon',
               rows: [
                  { name: 'Laki-laki', value: `${tkiL} Orang` },
                  { name: 'Perempuan', value: `${tkiP} Orang` },
                  { name: 'Total', value: `${tkiL + tkiP} Orang` },
               ],
            },
            {
               title: 'Rencana Nilai Investasi',
               icon: 'DollarSignIcon',
               rows: [
                  { name: 'Modal Tetap', value: formatNumber(Number(item.modal_kerja || 0)) },
                  { name: 'Modal Kerja', value: formatNumber(Number(item.jumlah_investasi || 0)) },
                  {
                     name: 'Total',
                     value: formatNumber(Number(item.modal_kerja || 0) + Number(item.jumlah_investasi || 0)),
                  },
               ],
            },
            {
               title: 'Tambahan Nilai Investasi',
               icon: 'TrendingUpIcon',
               rows: [
                  { name: 'Modal Tetap', value: formatNumber(Number(item.modal_tetap_p_pelaporan || 0)) },
                  { name: 'Modal Kerja', value: formatNumber(Number(item.modal_kerja_p_pelaporan || 0)) },
                  { name: 'Total Realisasi', value: formatNumber(Number(item.jumlah_realisasi_ppelaporan || 0)) },
               ],
            },
         ]
      },
      onCetakRow(id) {
         this.loadingPdf = true
         this.cetakLkpm(id).then(res => {
            const blob = new Blob([res.data])
            this.pdf = URL.createObjectURL(blob)
            this.$refs.modalPdf.open()
            this.loadingPdf = false
         }, () => {
            this.loadingPdf = false
         })
      },
      onCetak() {
         if (!this.isFilterOpen) {
            this.$toast.error('Aktifkan filter untuk mencetak PDF')
            return
         }
         this.loadingPdf = true
         const params = {}
         const { filter } = this.serverParams
         if (filter.jenis_perusahaan !== null) {
            params.jenis_perusahaan = filter.jenis_perusahaan
         }
         if (filter.status_penanaman_modal !== null) {
            params.status_penanaman_modal = filter.status_penanaman_modal
         }
         if (filter.kd_skala_usaha !== null) {
            params.kd_skala_usaha = filter.kd_skala_usaha
         }
         if (filter.kd_resiko !== null) {
            params.kd_resiko = filter.kd_resiko
         }
         if (filter.sektor !== null) {
            params.sektor = filter.sektor
         }
         if (filter.perusahaan_daerah_id !== null) {
            params.perusahaan_daerah_id = filter.perusahaan_daerah_id
            params.daerah_mode = filter.daerah_mode
         }
         if (filter.periode_lkpm !== null) {
            params.periode_lkpm = filter.periode_lkpm
         }
         if (filter.tahun_lkpm !== null) {
            params.tahun_lkpm = filter.tahun_lkpm
         }
         if (filter.status !== null) {
            params.status = filter.status
         }
         if (this.searchTerm) {
            params.search = this.searchTerm
         }
         this.cetakListLkpm(params).then(res => {
            const blob = new Blob([res.data])
            this.pdf = URL.createObjectURL(blob)
            this.$refs.modalPdf.open()
            this.loadingPdf = false
         }, () => {
            this.loadingPdf = false
         })
      },

      // VUE GOOD TABLE
      async loadItems() {
         this.loading = true
         await this.getData(this.serverParams)
      },
      updateParams(newProps) {
         // eslint-disable-next-line prefer-object-spread
         this.serverParams = Object.assign({}, this.serverParams, newProps)
      },
      onPageChangePagination(page) {
         this.updateParams({ page })
         this.loadItems()
      },
      onPerPageChangePagination(perPage) {
         this.updateParams({ perPage, page: 1 })
         this.loadItems()
      },
      onColumnFilter(params) {
         this.updateParams({ ...params, page: 1 })
         this.loadItems()
      },
      onFilter() {
         this.serverParams.page = 1
         setTimeout(() => {
            this.loadItems()
         }, 100)
      },
      onShownCollapse() {
         this.isFilterOpen = true
         this.serverParams.page = 1
         const currentYear = new Date().getFullYear()
         if (this.serverParams.filter.tahun_lkpm !== currentYear) {
            this.serverParams.filter.tahun_lkpm = currentYear
            this.loadItems()
         }
      },
      onHiddenCollapse() {
         this.isFilterOpen = false
         this.serverParams.page = 1
         this.serverParams.filter.jenis_perusahaan = null
         this.serverParams.filter.status_penanaman_modal = null
         this.serverParams.filter.kd_skala_usaha = null
         this.serverParams.filter.kd_resiko = null
         this.serverParams.filter.sektor = null
         this.serverParams.filter.perusahaan_daerah_id = null
         this.serverParams.filter.daerah_mode = 'kecamatan'
         this.serverParams.filter.periode_lkpm = null
         this.serverParams.filter.tahun_lkpm = null
         this.serverParams.filter.status = null
         this.loadItems()
      },
      onSearch: debounce(function search(params) {
         this.serverParams.search = params
         this.serverParams.page = 1
         this.loadItems()
      }, 500),
   },
}
</script>

<template>
   <div>
      <b-card-code title="LKPM UMK">
         <!-- search input -->
         <b-row>
            <!-- TOOLBAR -->
            <b-col cols="12" md="6">
               <b-form @submit.stop.prevent>
                  <div class="d-flex align-items-center justify-content-end">
                     <b-form-input
                        v-model="searchTerm"
                        class="d-inline-block mb-1"
                        placeholder="Search..."
                        autocomplete="off"
                        type="text"
                        aria-label="Search"
                        @input="onSearch"
                     />
                  </div>
               </b-form>
            </b-col>
            <b-col cols="12" md="6">
               <div class="d-flex justify-content-end">
                  <b-button-group class="mb-1">
                     <b-button v-b-toggle.collapse-filter variant="outline-secondary" size="sm">
                        <feather-icon icon="FilterIcon" />
                     </b-button>
                     <b-button
                        v-b-tooltip.hover.top="'Cetak PDF'"
                        variant="outline-secondary"
                        size="sm"
                        @click="onCetak()"
                     >
                        <feather-icon icon="FileTextIcon" />
                     </b-button>
                     <b-button variant="outline-secondary" size="sm" @click="loadItems()">
                        <feather-icon icon="RefreshCwIcon" />
                     </b-button>
                     <b-dropdown variant="outline-secondary" right text="Menu" size="sm">
                        <b-dropdown-item @click="onFilter()">
                           Filter
                        </b-dropdown-item>
                        <b-dropdown-item @click="onCetak()">
                           Cetak PDF
                        </b-dropdown-item>
                        <b-dropdown-item @click="loadItems()">
                           Refresh
                        </b-dropdown-item>
                     </b-dropdown>
                  </b-button-group>
               </div>
            </b-col>

            <!-- FILTER -->
            <b-col cols="12">
               <b-collapse id="collapse-filter" class="mt-2" @shown="onShownCollapse" @hidden="onHiddenCollapse">
                  <b-card class="border">
                     <b-row>
                        <b-col md="3">
                           <b-form-group label="Jenis Perusahaan" label-for="jenis-perusahaan">
                              <v-select
                                 id="jenis-perusahaan"
                                 v-model="serverParams.filter.jenis_perusahaan"
                                 :options="optionsJenisPerusahaan"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Jenis..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Status Penanaman Modal" label-for="status-pm">
                              <v-select
                                 id="status-pm"
                                 v-model="serverParams.filter.status_penanaman_modal"
                                 :options="optionsStatusPM"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Status PM..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Skala Usaha" label-for="skala-usaha">
                              <v-select
                                 id="skala-usaha"
                                 v-model="serverParams.filter.kd_skala_usaha"
                                 :options="optionsSkalaUsaha"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Skala..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Risiko" label-for="risiko">
                              <v-select
                                 id="risiko"
                                 v-model="serverParams.filter.kd_resiko"
                                 :options="optionsStatusResiko"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Risiko..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                     </b-row>

                     <b-row class="mt-2">
                        <b-col md="3">
                           <b-form-group label="Sektor" label-for="sektor">
                              <v-select
                                 id="sektor"
                                 v-model="serverParams.filter.sektor"
                                 :options="optionsSektor"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Sektor..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Status" label-for="status-lkpm">
                              <v-select
                                 id="status-lkpm"
                                 v-model="serverParams.filter.status"
                                 :options="optionsStatusLkpm"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Status..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Periode LKPM" label-for="periode-lkpm">
                              <v-select
                                 id="periode-lkpm"
                                 v-model="serverParams.filter.periode_lkpm"
                                 :options="optionsPeriodeLkpm"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Periode..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="3">
                           <b-form-group label="Tahun LKPM" label-for="tahun-lkpm">
                              <v-select
                                 id="tahun-lkpm"
                                 v-model="serverParams.filter.tahun_lkpm"
                                 :options="optionsTahunLkpm"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Tahun..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                     </b-row>

                     <b-row class="mt-2">
                        <b-col md="3">
                           <b-form-group label="Daerah" label-for="daerah">
                              <b-form-radio-group
                                 id="daerah-mode"
                                 v-model="serverParams.filter.daerah_mode"
                                 :options="[{ text: 'Kecamatan', value: 'kecamatan' }, { text: 'Kelurahan/Desa', value: 'kelurahan' }]"
                                 class="mb-1"
                                 @change="serverParams.filter.perusahaan_daerah_id = null; onFilter()"
                              />
                              <v-select
                                 id="daerah"
                                 v-model="serverParams.filter.perusahaan_daerah_id"
                                 :options="optionsDaerah"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih Daerah..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>

                     </b-row>
                  </b-card>
               </b-collapse>
            </b-col>
            <!-- FILTER -->
         </b-row>

         <!-- table -->
         <vue-good-table
            ref="goodTable"
            mode="remote"
            :columns="columns"
            :rows="myData"
            :total-rows="myCount"
            :is-loading.sync="loading"
            :line-numbers="true"
            :pagination-options="{
               enabled: true,
               mode: 'pages',
            }"
            :search-options="{
               enabled: true,
               externalQuery: searchTerm,
            }"
            @on-column-filter="onColumnFilter"
            @on-search="onSearch"
         >
            <template slot="table-row" slot-scope="props">
               <!-- Column: LKPM -->
               <span v-if="props.column.field == 'nomor_lkpm'">
                  <b>{{ props.row.id_laporan || '-' }}</b>
                  <hr>
                  <small>Periode : {{ periodeLabel(props.row.periode_laporan) }}</small>
                  <hr>
                  <small>Tahun : {{ props.row.tahun_laporan || '-' }}</small>
                  <hr>
                  <small>Tgl Laporan : {{ momentDate(props.row.tanggal_laporan) }}</small>
                  <hr>
                  <b-badge :variant="statusVariant(props.row.status)">
                     {{ props.row.status || '-' }}
                  </b-badge>
               </span>

               <!-- Column: NIB -->
               <span v-if="props.column.field == 'nib'">
                  <b>{{ props.row.nama_perusahaan }}</b>
                  <hr>
                  <b class="text-primary">{{ props.row.nib }}</b>
                  <hr>
                  <small>{{ jenisPerusahaan(props.row.jenis_perusahaan) }}</small>
                  <hr>
                  <small>{{ statusPM(props.row.status_penanaman_modal) }}</small>
                  <hr>
                  <small>ID Proyek : {{ props.row.id_proyek }}</small>
               </span>

               <!-- Column: Bidang Usaha -->
               <span v-if="props.column.field == 'kbli'">
                  <b>KBLI : {{ props.row.kbli }}</b>
                  <hr>
                  <small>{{ props.row.kbli_nama || '-' }}</small>
                  <hr>
                  <small>
                     Nama Usaha :
                     <b>{{ props.row.nama_usaha || '-' }}</b>
                  </small>
                  <hr>
                  <table class="borderless">
                     <tr>
                        <td><small>Risiko</small></td>
                        <td><small>&nbsp;:&nbsp;</small></td>
                        <td><small>{{ statusResiko(props.row.kd_resiko) }}</small></td>
                     </tr>
                     <tr>
                        <td><small>Skala</small></td>
                        <td><small>&nbsp;:&nbsp;</small></td>
                        <td><small>{{ skalaUsaha(props.row.kd_skala_usaha) }}</small></td>
                     </tr>
                     <tr>
                        <td><small>Sektor</small></td>
                        <td><small>&nbsp;:&nbsp;</small></td>
                        <td>
                           <small>{{ sektorCode(props.row.sektor) }}</small>
                        </td>
                     </tr>
                  </table>
               </span>

               <!-- Column: Tambahan Tenaga Kerja -->
               <span v-if="props.column.field == 'tenaga_kerja'">
                  <table class="borderless">
                     <tr>
                        <td><small>Laki-laki</small></td>
                        <td><small>&nbsp;:&nbsp;</small></td>
                        <td><small>{{ props.row.tambahan_tki_l_ppelaporan || 0 }}</small></td>
                     </tr>
                     <tr>
                        <td><small>Perempuan</small></td>
                        <td><small>&nbsp;:&nbsp;</small></td>
                        <td><small>{{ props.row.tambahan_tki_p_ppelaporan || 0 }}</small></td>
                     </tr>
                     <tr>
                        <td><small>Total</small></td>
                        <td><small>&nbsp;:&nbsp;</small></td>
                        <td>
                           <b>
                              <small>{{
                                 Number(props.row.tambahan_tki_l_ppelaporan || 0)
                                    + Number(props.row.tambahan_tki_p_ppelaporan || 0)
                              }}</small>
                           </b>
                        </td>
                     </tr>
                  </table>
               </span>

               <!-- Column: Rencana Nilai Investasi -->
               <span v-if="props.column.field == 'rencana_investasi'">
                  <table class="borderless">
                     <tr>
                        <td><small>Modal Tetap</small></td>
                        <td><small>&nbsp;:&nbsp;</small></td>
                        <td>
                           <small>{{ (props.row.modal_kerja || 0) | formatNumber }}</small>
                        </td>
                     </tr>
                     <tr>
                        <td><small>Modal Kerja</small></td>
                        <td><small>&nbsp;:&nbsp;</small></td>
                        <td>
                           <small>{{ (props.row.jumlah_investasi || 0) | formatNumber }}</small>
                        </td>
                     </tr>
                     <tr>
                        <td><small>Total</small></td>
                        <td><small>&nbsp;:&nbsp;</small></td>
                        <td>
                           <b>
                              <small>{{
                                 (Number(props.row.modal_kerja || 0) + Number(props.row.jumlah_investasi || 0)) | formatNumber
                              }}</small>
                           </b>
                        </td>
                     </tr>
                  </table>
               </span>

               <!-- Column: Tambahan Nilai Investasi -->
               <span v-if="props.column.field == 'tambahan_investasi'">
                  <table class="borderless">
                     <tr>
                        <td><small>Modal Tetap</small></td>
                        <td><small>&nbsp;:&nbsp;</small></td>
                        <td>
                           <small>{{ (props.row.modal_tetap_p_pelaporan || 0) | formatNumber }}</small>
                        </td>
                     </tr>
                     <tr>
                        <td><small>Modal Kerja</small></td>
                        <td><small>&nbsp;:&nbsp;</small></td>
                        <td>
                           <small>{{ (props.row.modal_kerja_p_pelaporan || 0) | formatNumber }}</small>
                        </td>
                     </tr>
                     <tr>
                        <td><small>Total</small></td>
                        <td><small>&nbsp;:&nbsp;</small></td>
                        <td>
                           <b>
                              <strong><small>{{ (props.row.jumlah_realisasi_ppelaporan || 0) | formatNumber }}</small></strong>
                           </b>
                        </td>
                     </tr>
                  </table>
               </span>

               <!-- Column: Action -->
               <span v-if="props.column.field == 'action'">
                  <b-button
                     v-b-tooltip.hover.top="'Cetak LKPM'"
                     variant="relief-primary"
                     size="sm"
                     block
                     class="mb-50"
                     :disabled="!props.row.s3_path"
                     @click="onCetakRow(props.row.id)"
                  >
                     <feather-icon icon="PrinterIcon" />
                  </b-button>
                  <b-button
                     v-b-tooltip.hover.top="'Detail'"
                     variant="relief-secondary"
                     size="sm"
                     block
                     @click="onDetail(props.row)"
                  >
                     <feather-icon icon="EyeIcon" />
                  </b-button>
               </span>
            </template>

            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
               <pagination-custom
                  :total="props.total"
                  :page-length="pageLength"
                  :page-options="pageOptions"
                  :page="serverParams.page"
                  :page-changed="props.pageChanged"
                  :per-page-changed="props.perPageChanged"
                  @update:page="onPageChangePagination"
                  @update:perpage="onPerPageChangePagination"
               />
            </template>
         </vue-good-table>
      </b-card-code>

      <b-modal
         id="modal-detail"
         scrollable
         size="xl"
         hide-footer
         title="Detail LKPM UMK"
      >
         <!-- header detail -->
         <b-card class="shadow-sm border-0 mb-2" no-body>
            <b-card-header class="bg-transparent border-bottom py-1">
               <div class="d-flex align-items-center">
                  <b-avatar variant="primary" size="lg" class="shadow-sm mr-2">
                     <feather-icon size="24" icon="FileTextIcon" />
                  </b-avatar>
                  <div class="d-flex flex-column">
                     <h4 class="mb-0 font-weight-bolder text-body-heading">
                        {{ detailItem.nama_perusahaan || 'Detail LKPM UMK' }}
                     </h4>
                     <small class="text-muted">
                        NIB: {{ detailItem.nib || '-' }} &bull; LKPM: {{ detailItem.nomor_lkpm || '-' }}
                     </small>
                  </div>
                  <b-badge :variant="statusVariant(detailItem.status)" class="ml-5">
                     {{ detailItem.status || '-' }}
                  </b-badge>
               </div>
            </b-card-header>
         </b-card>

         <!-- section detail -->
         <b-row>
            <b-col
               v-for="(section, sIndex) in detailSections"
               :key="`section-${sIndex}`"
               cols="12"
               md="6"
               xl="4"
               class="mb-2"
            >
               <b-card
                  class="shadow h-100 mb-2 detail-card"
                  :header="section.title"
                  header-class="font-weight-bold text-body border-bottom"
               >
                  <template #header>
                     <div class="d-flex align-items-center">
                        <feather-icon :icon="section.icon" size="16" class="mr-50 text-primary" />
                        <span class="font-weight-bold">{{ section.title }}</span>
                     </div>
                  </template>
                  <b-table-simple small borderless hover class="mb-0">
                     <b-tbody>
                        <b-tr v-for="(row, index) in section.rows" :key="`s${sIndex}-r${index}`">
                           <b-td class="text-muted font-weight-bold border-0 py-1" width="45%">
                              {{ row.name }}
                           </b-td>
                           <b-td class="text-right text-break border-0 py-1">
                              {{ row.value }}
                           </b-td>
                        </b-tr>
                     </b-tbody>
                  </b-table-simple>
               </b-card>
            </b-col>
         </b-row>
      </b-modal>

      <sweet-modal ref="modalPdf" modal-theme="light" overlay-theme="dark" width="80%">
         <div style="height: 70vh;">
            <vue-pdf-app :pdf="pdf" />
         </div>
      </sweet-modal>
   </div>
</template>

<style scoped>
.borderless > tr > td {
   border: none;
   padding: 0em;
}
table > tbody > tr > td > span > hr {
   margin-top: 0rem;
   margin-bottom: 0rem;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#modal-detail {
   .detail-card {
      border-left: 4px solid #7367f0 !important;

      .card-header {
         background-color: transparent;
      }

      .table td {
         vertical-align: middle;
      }
   }
}
</style>
